module.exports = __webpack_public_path__ + "img/臻泰智能.ae5ad64a.png";